import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

/**
 * Order matters here. We want all auth/* routes to take precedence over path: '', because
 * the DashboardModule handles incorrect routes by using a path: '**' statement.
 * If the AuthModule is not loaded first, then the path: '**' will capture all auth routes as invalid.
 */
const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./views/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
  }
];

@NgModule({
  // 'computed' steps the browser forward again when a guard cancels a back navigation (e.g. "Keep editing" on the
  // unsaved-changes modal). The default 'replace' leaves the history pointer one entry back and overwrites that entry
  // with the current url, so the next back button press skips past it or does nothing.
  imports: [RouterModule.forRoot(routes, { canceledNavigationResolution: 'computed' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
